export const hideHotspotIcon = (icon) => {
  icon.style.visibility = 'hidden';
  icon.style.opacity = 0;
};
